import { mixpanelEvents } from '@/constants/mixpanel';
import queryKeys from '@/constants/queryKeys';
import useTelemetry from '@/providers/TelemetryProvider/useTelemetry';
import { createGoalPost } from '@/services/api/requests/growthZone';
import { THealthDomainWithOverall } from '@/types/Health.types';
import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';

const useCreateGoalForDomain = (domain: THealthDomainWithOverall, onSuccessCallback?: () => void) => {
  const toast = useToast();
  const { trackEvent } = useTelemetry();

  const { isPending, isSuccess, mutate } = useMutation({
    mutationKey: [queryKeys.growthZone.newGoal],
    mutationFn: async (newDomainGoalText: string) => {
      await createGoalPost({ domain, text: newDomainGoalText });
    },
    onSuccess: () => {
      onSuccessCallback?.();

      trackEvent(mixpanelEvents.GOAL_CREATED, { domain });
    },
    onError: (error) => {
      toast({
        title: 'Error creating a goal',
        description: error instanceof Error ? error.message : 'An unexpected error occurred.',
        status: 'error',
      });
    },
  });

  return {
    isPending,
    mutate,
    isSuccess,
  };
};

export default useCreateGoalForDomain;
